---
nb:
  contract:
    active: Aktiv
    counterpart: Motpart
    end_date: Kontraktsluttdato
    errors:
      ownership_unscaled_on_shadow: Innmatingstariff- og sikringskontrakter kan ikke knyttes til et skyggekraftverk, som ikke har en eierandel til å fordele delt produksjon.
    open_ended: Kontrakt på ubestemt tid
    power_plant: Kraftverk
    power_plants: Kraftverk
    start_date: Kontraktsstartdato
    type: Kontrakstype
